/* tslint:disable */

/* eslint-disable */

/**
 * API Gateway Backstage Plugin
 * Backstage plugins api spec
 *
 * The version of the OpenAPI document: v1
 * Contact: sarkan.mo@tomtom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Link
 */
export interface Link {
  /**
   * The name of the link.
   * @type {string}
   * @memberof Link
   */
  name?: string;
  /**
   * The URL.
   * @type {string}
   * @memberof Link
   */
  link?: string;
}

/**
 * Check if a given object implements the Link interface.
 */
// @ts-ignore
export function instanceOfLink(value: object): value is Link {
  return true;
}

export function LinkFromJSON(json: any): Link {
  return LinkFromJSONTyped(json, false);
}

export function LinkFromJSONTyped(
  json: any,
  // @ts-ignore
  ignoreDiscriminator: boolean,
): Link {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'] == null ? undefined : json['name'],
    link: json['link'] == null ? undefined : json['link'],
  };
}

export function LinkToJSON(json: any): Link {
  return LinkToJSONTyped(json, false);
}

export function LinkToJSONTyped(
  value?: Link | null,
  // @ts-ignore
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value['name'],
    link: value['link'],
  };
}
